function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef, memo, useCallback } from 'react';
import { ChevronDownIcon, Select, View } from 'native-base';
const DropDownIcon = () => /*#__PURE__*/React.createElement(View, {
  w: "12.5",
  h: "100%",
  borderLeftWidth: "2",
  borderColor: "#687583",
  justifyContent: "center",
  alignItems: "center",
  bg: "#d6e0ec80",
  borderRadius: "0"
}, /*#__PURE__*/React.createElement(ChevronDownIcon, {
  color: "primary.400",
  size: "5"
}));
const DropDown = (_ref, ref) => {
  let {
    list,
    ...rest
  } = _ref;
  const RenderSelectItemList = useCallback(_ref2 => {
    let {
      label,
      value,
      id
    } = _ref2;
    return (
      /*#__PURE__*/
      //@ts-ignore
      React.createElement(Select.Item, {
        label: label,
        value: value,
        key: id
      })
    );
  }, []);
  return /*#__PURE__*/React.createElement(Select, _extends({}, rest, {
    ref: ref,
    h: "12.5",
    bg: 'white.700',
    color: "text.running",
    placeholderTextColor: "text.running",
    variant: "unstyled",
    dropdownIcon: /*#__PURE__*/React.createElement(DropDownIcon, null)
  }), list.map(RenderSelectItemList));
};
export default /*#__PURE__*/memo( /*#__PURE__*/forwardRef(DropDown));
//# sourceMappingURL=DropDown.js.map